const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL

// this should be getting account, account carriers, and account product settings
// may want to also look at adding like an 'overlay gif' to show loading while the call is being made ?
function retrieveAccount(){
    let currentDomain = window && window.location && window.location.hostname

    // set from env files based on enviorment
    const isDev = (process.env.REACT_APP_IS_DEV_ENVIRONMENT === 'true')

    // check for query string override
    if (isDev){
        const domainOverride = getAccountDomainOverrideFromQueryString()

        if(domainOverride)
            currentDomain = domainOverride
    }

    const x = fetch(`${covrServicesUrl}/api/Account?Domain=${currentDomain}`, {
        method: 'GET'
    })
    .then(x => x.json())

    return x
}

export { retrieveAccount }

const getAccountDomainOverrideFromQueryString = () => {
    const key = 'domain'
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

function getAccountSettings(oneClickAccountId) {
  const settings = fetch(`${covrServicesUrl}/API/Account/GetAccountSettingsFromBms?oneClickAccountId=${oneClickAccountId}`, {
    method: 'GET'
  })
  .then(settings => settings.json())

  return settings;
}

export { getAccountSettings }


// WEBPACK FOOTER //
// ./src/account.js